/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_Translation_TextInputs */



/**
* | output |
* | --- |
* | "Translation text" |
*
* @param {Event_Group_Sync_Property_Translation_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_translation_text = /** @type {((inputs?: Event_Group_Sync_Property_Translation_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_Translation_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Translation text")
	if (locale === "de") return /** @type {LocalizedString} */ ("Translation text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Translation text")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Translation text")
	if (locale === "es") return /** @type {LocalizedString} */ ("Translation text")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Translation text")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Translation text")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Translation text")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Translation text")
	return /** @type {LocalizedString} */ ("Translation text")
});